import anime from 'animejs';

export const initLoadingSpinner = wrapperClass => {
  const loaderWrappers = document.querySelectorAll(wrapperClass);

  loaderWrappers.forEach(wrapper => {
    anime({
      targets: wrapper.querySelectorAll('.loading-spinner path'),
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: 'easeInOutSine',
      duration: 1000,
      direction: 'normal',
      loop: true,
    });

    wrapper.querySelector('.loading-spinner')?.classList.add('is-loading');
  });
};

export const stopLoadingSpinner = wrapperClass => {
  const loaderWrappers = document.querySelectorAll(wrapperClass);

  loaderWrappers.forEach(wrapper => {
    wrapper.querySelector('.loading-spinner')?.classList.remove('is-loading');
  });
};
